import { createFileRoute, redirect } from '@tanstack/react-router'
import i18next from 'i18next'
import { enqueueSnackbar } from 'notistack'
import { analyzeReportsQuery } from '../../data/analyze/reports.ts'
import { DisplayHailReport } from '../../features/reports/display-form/hail/DisplayHailReport.tsx'

export const Route = createFileRoute('/_app/reports/hail/$id')({
	component: DisplayHailReport,
	beforeLoad: ({ context: { isAdmin, isLimitedAdmin, sub, impersonation } }) => {
		if ((!isAdmin && !isLimitedAdmin) || (!impersonation && !sub.features.includes('analyze'))) {
			throw redirect({ to: '/' })
		}
	},
	loader: async ({ params: { id }, context: { queryClient, impersonation } }) => {
		const reports = await queryClient.ensureQueryData(analyzeReportsQuery('HAIL', impersonation))

		const report = reports.find((report) => report.id === id)
		if (report?.status !== 'COMPLETED') {
			enqueueSnackbar({ variant: 'error', message: i18next.t(($) => $.reports.display.reportDoesNotExistOrIsNotProcessed) })
			throw redirect({ to: '/reports' })
		}

		return { report }
	},
})
